import {Text} from '@/components-v2/atoms'
import {RewardDiscount} from './Rewards'
import {PromotionType} from '@/utils/constants/promotionConstants'
import {BuyMultipleProductsCondition} from './BuyMultipleProductsCondition'
import {BuySingleProductCondition} from './BuySingleProductCondition'

/** Renders the v2 condition layer matching the promotion type. */
export const PromotionConditions = ({condition, promotionType, index, selectedPromotionCondition}) => {
  const renderConditionContent = () => {
    switch (promotionType) {
      case PromotionType.BUY_PRODUCT:
        return (
          <BuySingleProductCondition
            index={index}
            promotionCondition={condition}
            selectedPromotionCondition={selectedPromotionCondition}
          />
        )
      case PromotionType.STORE_DISCOUNT:
        return (
          <div className="flex items-center gap-4">
            <Text>Get</Text>
            <RewardDiscount
              index={index}
              promotionCondition={condition}
              selectedPromotionCondition={selectedPromotionCondition}
            />
          </div>
        )
      case PromotionType.WELCOME_DISCOUNT:
        return (
          <div className="flex items-center gap-4">
            <Text>Get</Text>
            <RewardDiscount
              index={index}
              promotionCondition={condition}
              textAfterInput="% off, after first order."
              selectedPromotionCondition={selectedPromotionCondition}
            />
          </div>
        )
      case PromotionType.BUY_MULTIPLE:
        return (
          <BuyMultipleProductsCondition
            index={index}
            promotionCondition={condition}
            selectedPromotionCondition={selectedPromotionCondition}
          />
        )
      default:
        return null
    }
  }

  return <div className="flex flex-wrap items-center gap-4 pt-2">{renderConditionContent()}</div>
}
